"use client";

import { darkMode } from "@/store/darkMode/darkMode-store";
import { createTheme, ThemeProvider } from "@mui/material";
import React from "react";

const typography = {
  fontFamily: "var(--font-dm-sans), sans-serif",
};

const lightTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#104aa5",
    },
    secondary: {
      main: "#092b5b",
    },
    background: {
      default: "#f0f4f8",
      paper: "#ffffff",
    },
  },
  typography,
});

const darkThemeMaterial = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#104aa5",
    },
    secondary: {
      main: "#a8c4f0",
    },
    background: {
      default: "#0d1321",
      paper: "#151c2e",
    },
    text: {
      primary: "#ffffff",
      secondary: "#a8c4f0",
    },
  },
  typography,
});

export const ThemeProviderMaterialUi = ({ children }: { children: React.ReactNode }) => {
  const { isDark } = darkMode();

  return (
    <ThemeProvider theme={isDark ? darkThemeMaterial : lightTheme}>
      {children}
    </ThemeProvider>
  );
};
